import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { APPCONFIG } from '../../_store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-qr-code-generator',
  templateUrl: './app-qr-code-generator.component.html',
  styleUrls: ['./app-qr-code-generator.component.scss'],
})
export class AppQrCodeGeneratorComponent implements OnInit {
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  @Input() invNo: any = '';
  value = '';

  constructor(
    public activeModal: NgbActiveModal,
    private translate : TranslateService
  ) { }

  ngOnInit() {
    this.init();
  }

  init() {
    const url = `${location.href.split('#')[0]}#/invoices/pay/${this.invNo}`;
    this.value = url;
    console.log(this.value);
  }

  close() {
    this.activeModal.close();
  }

}
